module.exports = __webpack_public_path__ + "src/assets/img/header-dummy-02.jpg";